import { getFunctions, httpsCallable } from "firebase/functions";
import { REGION } from "store/ref";
import { getApp } from "firebase/app";
import { PROJECT_ID } from "config/keys/user";

const app = getApp(PROJECT_ID);
const functions = getFunctions(app, REGION);

// get functions api.
export const getApiFunctions = () => {
  // login operator.
  const login = httpsCallable(functions, "api-operator-login-token");

  // generate token,
  const generateToken = httpsCallable(
    functions,
    "api-login-bailiff-token-generate"
  );

  // hàm add pin code.
  const emailSendCode = httpsCallable(
    functions,
    "api-email-verification-add-pincode"
  ); // { email, source },
  const emailCheckCode = httpsCallable(
    functions,
    "api-email-verification-check-pincode"
  ); // { email, source, pincode},

  // return.
  return {
    login,
    generateToken,

    email: {
      emailSendCode,
      emailCheckCode,
    },
  };
};
